import { render, staticRenderFns } from "./Certifications.vue?vue&type=template&id=21ef42e1"
import script from "./Certifications.vue?vue&type=script&lang=js"
export * from "./Certifications.vue?vue&type=script&lang=js"
import style0 from "./Certifications.vue?vue&type=style&index=0&id=21ef42e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports